import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { mockTransactions } from "../../data/mockData";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import EmailIcon from "@mui/icons-material/Email";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TrafficIcon from "@mui/icons-material/Traffic";
import Header from "../../components/Header";
import LineChart from "../../components/LineChart";
import GeographyChart from "../../components/GeographyChart";
import BarChart from "../../components/BarChart";
import StatBox from "../../components/StatBox";
import ProgressCircle from "../../components/ProgressCircle";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { API_BASE } from "../../api";
import trackingMap from "./researcher-tracking.png";

const Dashboard = (props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const sectionBorder =
    theme.palette.mode === "light" ? "#002B5C" : colors.primary[500];
  const [isDashboard, setIsDashboard] = useState(true);
  const [recentResearchers, setRecentResearchers] = useState([]);
  const [dailyActiveResearcherCount, setDailyActiveResearcherCount] = useState([]);
  const [totalActiveResearcherCount, setTotalActiveResearcherCount] = useState([]);
  const [dailySurveysCount, setDailySurveysCount] = useState(0);
  const [totalSurveysCount, setTotalSurveysCount] = useState(0);
  const [dailySurveysCountComplete, setDailySurveysCountComplete] = useState(0);
  const [surveysCountComplete, setSurveysCountComplete] = useState(0);
  const getRecentResearchers = async () => {
    const url = `${API_BASE}/recentResearchers`;
    await fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setRecentResearchers(data.result);
        setDailyActiveResearcherCount(data.activeResearchersCount);
        setTotalActiveResearcherCount(data.totalResearchersCount);
        return data.result;
      })
      .catch((err) => {
        console.log("Error: ", err);
      });
  };

  const getCounts = async () => {
    //let stateId = 33;
    const url = `${API_BASE}/totalSurveysCountWeb?role=${props.role}`;
    await fetch(url).then(response => {
      return response.json();
    })
      .then((data) => {
        setDailySurveysCount(data.dailySurveysCount);
        setTotalSurveysCount(data.totalSurveysCount);
        setDailySurveysCountComplete(data.dailySurveysCountComplete);
        setSurveysCountComplete(data.surveysCountComplete);
        return data;
      })
      .catch((err) => {
        console.log("Error: ", err);
      });
  }



  useEffect(() => {
    getRecentResearchers();
    getCounts();
    //getLineGraphData();

  }, []);

  const handleRedirect = () => {
    // Use the history object to navigate to another page
    window.location.replace('/geography'); // Replace '/other-page' with the desired URL
  };

  return (
    <Box m="20px">
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="DASHBOARD" subtitle="Matrize Survey Dashboard" />

        {/*<Box>
          <Button
            sx={{
              backgroundColor: colors.blueAccent[700],
              color: colors.grey[100],
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
            }}
          >
            <DownloadOutlinedIcon sx={{ mr: "10px" }} />
            Download Reports
          </Button>
          </Box>*/}
      </Box>

      {/* GRID & CHARTS */}
      <Box
        display="grid"
        gridTemplateColumns="repeat(13, 1fr)"
        gridAutoRows="140px"
        gap="20px"
      >
        {/* ROW 1 */}
        <Box
          gridColumn="span 2"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={totalSurveysCount}
            subtitle="Total Surveys"
            //progress="0.75"
            //increase="+14%"
            icon={
              <EmailIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 2"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={surveysCountComplete}
            subtitle="Completed Surveys"
            //progress="0.50"
            //increase="+21%"
            icon={
              <PointOfSaleIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 2"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={dailySurveysCount}
            subtitle="Daily Surveys"
            // progress="0.30"
            // increase="+5%"
            icon={
              <PersonAddIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 2"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={dailySurveysCountComplete}
            subtitle="Daily Completed Surveys"
            // progress="0.80"
            // increase="+43%"
            icon={
              <TrafficIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 2"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={dailyActiveResearcherCount}
            subtitle="Agents Active Today"
            // progress="0.80"
            // increase="+43%"
            icon={
              <TrafficIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 2"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={totalActiveResearcherCount}
            subtitle="Total Active Agents"
            // progress="0.80"
            // increase="+43%"
            icon={
              <TrafficIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>

        {/* ROW 2 */}
        <Box
          gridColumn="span 8"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
        >
          <Box
            mt="25px"
            p="0 30px"
            display="flex "
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography
                variant="h5"
                fontWeight="600"
                color={colors.grey[100]}
              >
                Statistics
              </Typography>
              <Typography
                variant="h3"
                fontWeight="bold"
                color={colors.greenAccent[500]}
              >
                {totalSurveysCount}
              </Typography>
            </Box>
            <Box>
              <IconButton>
                <DownloadOutlinedIcon
                  sx={{ fontSize: "26px", color: colors.greenAccent[500] }}
                />
              </IconButton>
            </Box>
          </Box>
          <Box height="250px" m="-20px 0 0 0">
            <LineChart isDashboard={isDashboard} role={props.role} />
          </Box>
        </Box>
        <Box
          gridColumn="span 4"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
          overflow="auto"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            borderBottom={`4px solid ${sectionBorder}`}
            colors={colors.grey[100]}
            p="15px"
          >
            <Typography color={colors.grey[100]} variant="h5" fontWeight="600">
              Recent Researchers
            </Typography>
          </Box>
          {recentResearchers?.map((research, i) => (
            <Box
              key={`${research.FullName}-${i}`}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              borderBottom={`4px solid ${sectionBorder}`}
              p="15px"
            >
              <Box>
                <Typography
                  color={colors.greenAccent[500]}
                  variant="h5"
                  fontWeight="600"
                >
                  {new Date(research.time).toLocaleDateString()}
                </Typography>
                {/*<Typography color={colors.grey[100]}>
                  //{research.phone}
          </Typography>*/}
              </Box>
              <Box color={colors.grey[100]}>{research.FullName.split(' ')[0]}</Box>
              <Box
                //backgroundColor={colors.greenAccent[500]}
                p="5px 10px"
                borderRadius="4px"
              >
                {research.phone}
              </Box>
            </Box>
          ))}
        </Box>

        {/* ROW 3 */}
        <Box
          gridColumn="span 4"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
          p="30px"
        >
          <Typography variant="h5" fontWeight="600">
            Survey Quality
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mt="25px"
          >
            <ProgressCircle size="125" />
            <Typography
              variant="h5"
              color={colors.greenAccent[500]}
              sx={{ mt: "15px" }}
            >
              {`Total ${totalSurveysCount} surveys are done.`}
            </Typography>
            <Typography>{`Including ${totalSurveysCount - surveysCountComplete} incomplete surveys.`}</Typography>
          </Box>
        </Box>
        <Box
          gridColumn="span 4"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
        >
          <Typography
            variant="h5"
            fontWeight="600"
            sx={{ padding: "30px 30px 0 30px" }}
          >
            Survey Comparison
          </Typography>
          <Box height="250px" mt="-20px">
            <BarChart isDashboard={isDashboard} role={props.role}/>
          </Box>
        </Box>
        <Box
          gridColumn="span 4"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
          padding="30px"
          maxHeight="300px"
        >
          <Typography variant="h5" fontWeight="600" sx={{ marginBottom: "15px" }}>
            Researcher's Tracking
          </Typography>
          <Box
            component={Link}
            to="/geography"
            display="block"
            sx={{
              maxHeight: 220,
              textDecoration: "none",
              color: "inherit",
              "& img": {
                display: "block",
                width: "100%",
                maxWidth: 440,
                height: "auto",
                maxHeight: 220,
                objectFit: "contain",
              },
            }}
          >
            <img
              src={trackingMap}
              alt="India map — open geography tracking"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
